import {
  createReusableStylesheet,
  iconFontReusableStylesheet,
  tcwebReusableStylesheet,
  viewerMenuOverridesReusableStylesheet,
  type ReusableStylesheet,
} from '@trimble/stylesheets';
import styles from '../styles.css?inline';

export const uiComponentsStylesheet = createReusableStylesheet(
  'ui-components:styles',
  styles
);

export const uiComponentsStylesheets: readonly ReusableStylesheet[] = [
  tcwebReusableStylesheet,
  viewerMenuOverridesReusableStylesheet,
  iconFontReusableStylesheet,
  uiComponentsStylesheet,
];
